import { useApiQuery } from '~/hooks';
import {
  getTransactionStatsApi,
  getTransactionsApi,
  getTransactionByIdApi,
  type TransactionFilters,
} from '../repository';
import { keepPreviousData } from '@tanstack/react-query';

export const TRANSACTION_QUERY_KEYS = {
  TRANSACTION_STATS: 'transaction-stats',
  TRANSACTIONS: 'transactions',
  TRANSACTION_BY_ID: 'transaction-by-id',
};

/**
 * Query hook to fetch transaction statistics
 */
export const useGetTransactionStatsQuery = () => {
  return useApiQuery({
    queryKey: [TRANSACTION_QUERY_KEYS.TRANSACTION_STATS],
    queryFn: () => getTransactionStatsApi(),
  });
};

/**
 * Query hook to fetch transactions with filtering and pagination
 */
export const useGetTransactionsQuery = (filters?: TransactionFilters) => {
  return useApiQuery({
    queryKey: [TRANSACTION_QUERY_KEYS.TRANSACTIONS, filters],
    queryFn: () => getTransactionsApi(filters),
    placeholderData: keepPreviousData,
  });
};

/**
 * Query hook to fetch a single transaction by ID
 */
export const useGetTransactionByIdQuery = (transactionId: string | null) => {
  return useApiQuery({
    queryKey: [TRANSACTION_QUERY_KEYS.TRANSACTION_BY_ID, transactionId],
    queryFn: () => getTransactionByIdApi(transactionId!),
    enabled: !!transactionId,
  });
};
